<button
  [type]="buttonType"
  class="btn btn-{{ theme }}"
  style="max-width: {{ maxWidth }};"
  (click)="onClickButton($event)"
  [disabled]="disabled"
>
  {{ label }}
</button>
